import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_TextField = _resolveComponent("TextField")!
  const _component_AutoCompleteField = _resolveComponent("AutoCompleteField")!
  const _component_DateInputField = _resolveComponent("DateInputField")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_TextAreaField = _resolveComponent("TextAreaField")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.model.Id == "" ? "Add Education History" : "Edit Education History"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              ref: "frmRegister",
              modelValue: _ctx.valid,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.valid) = $event)),
              "lazy-validation": "",
              class: "form-inputs"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createElementVNode("span", { class: "f-body-1" }, "Course", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      md: "4",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_TextField, {
                          readonly: _ctx.isHiringmanager,
                          dense: "",
                          rules: [_ctx.validations.required],
                          outlined: "",
                          placeholder: "Course Name",
                          modelValue: _ctx.model.University,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.University) = $event))
                        }, null, 8, ["readonly", "rules", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      md: "4",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AutoCompleteField, {
                          readonly: _ctx.isHiringmanager,
                          rules: [_ctx.validations.required],
                          dense: "",
                          outlined: "",
                          items: _ctx.educationStatuses,
                          placeholder: "Degree ( Level )",
                          modelValue: _ctx.model.Degree,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.Degree) = $event))
                        }, null, 8, ["readonly", "rules", "items", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      md: "4",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_AutoCompleteField, {
                          readonly: _ctx.isHiringmanager,
                          rules: [_ctx.validations.required],
                          dense: "",
                          outlined: "",
                          items: _ctx.studyFields,
                          placeholder: "Field Of Study",
                          modelValue: _ctx.model.StudyField,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.StudyField) = $event))
                        }, null, 8, ["readonly", "rules", "items", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createElementVNode("span", { class: "f-body-1" }, "Dates", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      md: "4",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DateInputField, {
                          readonly: _ctx.isHiringmanager,
                          "first-day-of-week": "1",
                          modelValue: _ctx.model.StartDate,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.StartDate) = $event)),
                          "hide-actions": "",
                          placeholder: "Start Date",
                          "prepend-icon": ""
                        }, null, 8, ["readonly", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      md: "4",
                      cols: "12"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DateInputField, {
                          readonly: _ctx.isHiringmanager,
                          "first-day-of-week": "1",
                          modelValue: _ctx.model.EndDate,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.EndDate) = $event)),
                          "hide-actions": "",
                          placeholder: "End date",
                          "prepend-icon": ""
                        }, null, 8, ["readonly", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      md: "4",
                      class: "pt-8 align-self-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_switch, {
                          readonly: _ctx.isHiringmanager,
                          modelValue: _ctx.model.StillStudying,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.StillStudying) = $event)),
                          label: "Currently Studying?"
                        }, null, 8, ["readonly", "modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createElementVNode("span", { class: "f-body-1" }, "Description", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_TextAreaField, {
                          readonly: _ctx.isHiringmanager,
                          modelValue: _ctx.model.Description,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.Description) = $event)),
                          placeholder: "What did you learn?"
                        }, null, 8, ["readonly", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        (!_ctx.isAfterSignUp)
          ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  md: "12",
                  class: "text-right"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isHiringmanager)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          class: "mr-5 secondary_btn",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.cancel())),
                          loading: _ctx.loading,
                          "prepend-icon": "mdi-cancel"
                        }, {
                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                            _createTextVNode(" Cancel")
                          ])),
                          _: 1
                        }, 8, ["loading"]))
                      : _createCommentVNode("", true),
                    (!_ctx.isHiringmanager)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          class: "primary_btn",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.save())),
                          loading: _ctx.loading,
                          "prepend-icon": "mdi-check"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.model.Id == "" ? "Add" : "Save"), 1)
                          ]),
                          _: 1
                        }, 8, ["loading"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_card_actions, {
              key: 1,
              class: "justify-end"
            }, {
              default: _withCtx(() => [
                (!_ctx.isHiringmanager)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      class: "secondary_btn",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.cancel())),
                      loading: _ctx.loading,
                      "prepend-icon": "mdi-cancel"
                    }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode(" Cancel")
                      ])),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                (!_ctx.isHiringmanager)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 1,
                      class: "primary_btn",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.save())),
                      loading: _ctx.loading,
                      "prepend-icon": "mdi-check"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.model.Id == "" ? "Add Education" : "Save"), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
      ]),
      _: 1
    })
  ]))
}